export const environment = {
  production: true,
  //apiURL: 'https://localhost:7105/api/', //dev
  apiURL: 'https://paybevdevapi.azurewebsites.net/api/', //dev
  key: 'n4JOKJTDqfKFL4YU',
  iv: '3UgutxiCXNyx6YEE',
};
export const environmentURL = {
  //  define your api end point here
  paybevURL: 'https://dev.paybev.app/', //dev

  // Supplier Portal URLS
  supplierURL: 'https://supplier-dev.paybev.app/', //dev
};

export const RetailEnvironmentURL = {
  apiURL: 'https://devpaybevretailapi.azurewebsites.net/api/', //dev
};
